import { Link } from 'react-router-dom';

import { cn, iaRa } from 'lib/helpers/utility';

const ControlLinkItem = ({ item, isActive, size = 'default', className }) => {
  const children = iaRa(item.children);
  const isOpen = children.length > 0 && (item.open ?? isActive);
  const isSmall = size === 'small';

  return (
    <div
      {...item.attributes}
      className={cn(
        'flex shrink-0 items-center rounded transition-[background-color,box-shadow] duration-200',
        (isActive || isOpen) && 'bg-white shadow-md',
        isOpen && 'pr-0.5'
      )}>
      <Link
        to={item.to}
        aria-current={isActive && !isOpen ? 'page' : undefined}
        {...item.labelAttributes}
        className={cn(
          'flex items-center whitespace-nowrap rounded text-sm font-500 transition-colors duration-150',
          isSmall ? 'h-6 px-2.5' : 'h-7 px-3',
          isOpen && 'text-primary-600',
          !isOpen && (isActive ? 'text-neutral-800' : 'text-neutral-600 hover:text-neutral-800'),
          className
        )}>
        {item.label}
      </Link>
      {children.length > 0 && (
        <div
          className={cn(
            'flex items-center gap-0.5 overflow-hidden transition-[max-width,opacity] duration-300 ease-out motion-reduce:transition-none',
            isOpen ? 'max-w-[720px] opacity-100' : 'max-w-0 opacity-0'
          )}>
          <span className="mx-1 h-4 w-px shrink-0 bg-neutral-200" aria-hidden="true" />
          {children.map((child) => (
            <Link
              key={child.value}
              to={child.to}
              tabIndex={isOpen ? undefined : -1}
              aria-current={child.isActive ? 'page' : undefined}
              {...child.attributes}
              className={cn(
                'flex items-center whitespace-nowrap rounded-[6px] px-2 text-[13px] transition-colors duration-150',
                isSmall ? 'h-5' : 'h-[22px]',
                child.isActive
                  ? 'bg-primary-50 font-600 text-primary-600'
                  : 'font-500 text-neutral-700 hover:bg-neutral-50'
              )}>
              {child.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ControlLinkItem;
